<div class="pledge-section">

  <div class="card" inViewport (inViewportAction)="vars.showDock.next(!$event.visible)">
    <img class="child-sip-banner-bg" src="/assets/images/portfolio/child_on_sip_banner_bg.png" alt="" srcset="">

    <div class="head">
      <div class="text">Start Contributing Today <span><i class="icon-heartfilled"></i> Save 12 lives / year</span></div>
      <div class="amount"><strong>{{paymentV2.getMinSipAmount(config?.order?.iso_currency)?.text}}</strong></div>
    </div>

    <div class="info-list">
      <div class="list-item"><i class="material-icons">done</i> <span>Aid critical patients every month</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Allocate funds to campaigns that you prefer</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Get regular updates about your impact</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Unlock special rewards</span></div>
    </div>

    <div class="payment-button">
      <app-sip-monthly-donor-count></app-sip-monthly-donor-count>
      <div class="btn">
        <app-payment-sip-dialog-btn [config]="{
            dialogBtnTheme: 'payment-btn-v1',
            dialogBtnLabel: 'Start Giving '+paymentV2.getMinSipAmount(config?.order?.iso_currency)?.text+' / Month' ,
            amount: paymentV2.getMinSipAmount(config?.order?.iso_currency)?.amount,
            currency: config?.order?.iso_currency,
            origin: config?.origin,
            hideDockBtn: true,
            redirectTo: 'welcome',
            last_pay_mode: config?.order?.payment_mode || null,
            one_tap_pay: (config?.order?.iso_currency?.toUpperCase() !== 'INR' && !config?.order?.payment_mode?.match('LINK') && config?.order?.payment_gateway?.match('stripe')) ? true : false,
            hideCardInfo: true,
            dialogBtnSkipFailed: true
          }" (clickEvent)="sendEvent()">
        </app-payment-sip-dialog-btn>
      </div>
      <div *ngIf="config?.order?.iso_currency?.toUpperCase() !== 'INR' && !config?.order?.payment_mode?.match('LINK') && config?.order?.payment_gateway?.match('stripe') && config?.order?.payment_details?.last4" class="cardInfo">Use Card: **** <strong>{{config?.order?.payment_details?.last4}}</strong> ({{config?.order?.donor?.full_name?.trim()}})</div>
      <div class="offer-note">
        <app-offer-note [v2]="true"></app-offer-note>
      </div>
    </div>

  </div>

</div>

<app-docker-btn [config]="{btnLabel: 'Start giving '+paymentV2.getMinSipAmount(config?.order?.iso_currency)?.text+' / month'}"></app-docker-btn>
